export abstract class AppError implements Error {
  public readonly customError = true

  constructor(
    public readonly name: string,
    public readonly message: string,
    public readonly title?: string,
    public readonly statusCode?: number
  ) {}
}
